module.exports = __webpack_public_path__ + "img/shulk-min.d65ee185.png";